export default ({ name, info, error, warning }) =>
  [
    info !== undefined && `${name}Info`,
    (error !== undefined || warning !== undefined) && `${name}Validation`,
  ].filter(id => !!id)
